import core from 'mathjs/core';

const math = core.create();

math.import(require('mathjs/lib/type/fraction'));
math.import(require('mathjs/lib/type/bignumber'));
math.import(require('mathjs/lib/type/number'));
math.import(require('mathjs/lib/type/chain'));

math.import(require('mathjs/lib/function/arithmetic/add'));
math.import(require('mathjs/lib/function/arithmetic/subtract'));
math.import(require('mathjs/lib/function/arithmetic/divide'));
math.import(require('mathjs/lib/function/arithmetic/mod'));
math.import(require('mathjs/lib/function/arithmetic/lcm'));
math.import(require('mathjs/lib/function/arithmetic/gcd'));
math.import(require('mathjs/lib/function/arithmetic/round'));
math.import(require('mathjs/lib/function/arithmetic/abs'));
math.import(require('mathjs/lib/function/statistics/max'));
math.import(require('mathjs/lib/function/statistics/min'));
math.import(require('mathjs/lib/function/relational/smaller'));
math.import(require('mathjs/lib/function/relational/equal'));

export default math;
